// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gateway-settings-tab {
  background-color: #ffffff;
  padding: 10px;
}

.payout-upload .file-upload-card {
  margin-top: 5px;
  height: fit-content;
}

.allowed-services-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding: 20px;
  /* background-color: #f9f9f9; */
}

.allowed-services-container .card {
  background-color: #ffffff;
  padding: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.allowed-services-container .card h5 {
  margin-bottom: 15px;
  font-size: 16px;
  color: #333;
}

.allowed-services-container .payment-options,
.api-options,
.live-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.allowed-services-container .payment-method {
  display: flex;
  align-items: center;
}

.allowed-services-container .payment-method input {
  margin-right: 10px;
}

.allowed-services-container .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.allowed-services-container .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.allowed-services-container .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 20px;
}

.allowed-services-container .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.allowed-services-container input:checked + .slider {
  background-color: #4caf50;
}

.allowed-services-container input:checked + .slider:before {
  transform: translateX(20px);
}

.limit-charge-container {
  border-radius: 8px;
  max-width: 900px;
  margin: 20px auto;
}

.limit-charge-container .select-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.limit-charge-container .select-wrapper {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}

.limit-charge-container .select-wrapper label {
  margin-bottom: 5px;
  font-weight: 500;
}

.limit-charge-container .select-wrapper select {
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
}

.limit-charge-container .input-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.limit-charge-container .input-group {
  flex: 1 1;
  margin-right: 15px;
}

.limit-charge-container .input-group:last-child {
  margin-right: 0;
}

.limit-charge-container .input-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.limit-charge-container .input-group input {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 14px;
}

.limit-charge-container .limit-section h5,
.charge-section h5 {
  margin-bottom: 15px;
}

.limit-charge-container .limit-section,
.charge-section {
  margin-top: 20px;
}

.payment-methods-container {
  /* background-color: #fff; */
  padding: 20px;
  border-radius: 8px;
  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); */
  /* max-width: 400px; */
  margin: 20px auto;
}

.payment-methods-container h5 {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
}

.payment-methods-container .payment-methods-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Three currencies per row */
  gap: 15px;
}

.payment-methods-container .payment-method {
  display: flex;
  align-items: center;
}

.payment-methods-container .payment-method input {
  margin-right: 10px;
}

.payment-methods-container .selected-methods {
  margin-top: 20px;
}

.payment-methods-container .selected-methods h6 {
  font-weight: 600;
  margin-bottom: 10px;
}

.payment-methods-container .selected-methods ul {
  list-style-type: disc;
  padding-left: 20px;
}

.payment-methods-container .selected-methods p {
  font-style: italic;
  color: #888;
}

.update-btn {
  background-color: #0584fe;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 15px;
  transition: background-color 0.3s;
}

.payment-methods-container .update-btn:hover {
  background-color: #0467c4;
}

.payment-methods-container .update-message {
  margin-top: 10px;
  color: #106745;
  font-weight: 600;
  font-size: 14px;
}

.currencies-container {
  padding: 20px;
  border-radius: 8px;
  margin: 20px auto;
}

.currencies-container h5 {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
}

.currencies-container .currencies-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Three currencies per row */
  gap: 15px;
}

.currencies-container .currency-option {
  display: flex;
  align-items: center;
}

.currencies-container .currency-option input {
  margin-right: 10px;
}

.currencies-container .selected-currencies {
  margin-top: 20px;
}

.currencies-container .selected-currencies h6 {
  font-weight: 600;
  margin-bottom: 10px;
}

.currencies-container .selected-currencies ul {
  list-style-type: disc;
  padding-left: 20px;
}

.currencies-container .selected-currencies p {
  font-style: italic;
  color: #888;
}

.currencies-container .update-btn {
  background-color: #0584fe;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 15px;
  transition: background-color 0.3s;
}

.currencies-container .update-btn:hover {
  background-color: #0467c4;
}

.currencies-container .update-message {
  margin-top: 10px;
  color: #106745;
  font-weight: 600;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/payment-gateway/gateway-settings/Settings.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gDAAgD;EAChD,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,6BAA6B;EACpE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,6BAA6B;EACpE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".gateway-settings-tab {\n  background-color: #ffffff;\n  padding: 10px;\n}\n\n.payout-upload .file-upload-card {\n  margin-top: 5px;\n  height: fit-content;\n}\n\n.allowed-services-container {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  padding: 20px;\n  /* background-color: #f9f9f9; */\n}\n\n.allowed-services-container .card {\n  background-color: #ffffff;\n  padding: 20px;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.allowed-services-container .card h5 {\n  margin-bottom: 15px;\n  font-size: 16px;\n  color: #333;\n}\n\n.allowed-services-container .payment-options,\n.api-options,\n.live-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.allowed-services-container .payment-method {\n  display: flex;\n  align-items: center;\n}\n\n.allowed-services-container .payment-method input {\n  margin-right: 10px;\n}\n\n.allowed-services-container .switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  height: 20px;\n}\n\n.allowed-services-container .switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.allowed-services-container .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 20px;\n}\n\n.allowed-services-container .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\n.allowed-services-container input:checked + .slider {\n  background-color: #4caf50;\n}\n\n.allowed-services-container input:checked + .slider:before {\n  transform: translateX(20px);\n}\n\n.limit-charge-container {\n  border-radius: 8px;\n  max-width: 900px;\n  margin: 20px auto;\n}\n\n.limit-charge-container .select-section {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.limit-charge-container .select-wrapper {\n  display: flex;\n  flex-direction: column;\n  margin-right: 20px;\n}\n\n.limit-charge-container .select-wrapper label {\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.limit-charge-container .select-wrapper select {\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n}\n\n.limit-charge-container .input-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.limit-charge-container .input-group {\n  flex: 1;\n  margin-right: 15px;\n}\n\n.limit-charge-container .input-group:last-child {\n  margin-right: 0;\n}\n\n.limit-charge-container .input-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.limit-charge-container .input-group input {\n  width: 100%;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n}\n\n.limit-charge-container .limit-section h5,\n.charge-section h5 {\n  margin-bottom: 15px;\n}\n\n.limit-charge-container .limit-section,\n.charge-section {\n  margin-top: 20px;\n}\n\n.payment-methods-container {\n  /* background-color: #fff; */\n  padding: 20px;\n  border-radius: 8px;\n  /* box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); */\n  /* max-width: 400px; */\n  margin: 20px auto;\n}\n\n.payment-methods-container h5 {\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.payment-methods-container .payment-methods-list {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* Three currencies per row */\n  gap: 15px;\n}\n\n.payment-methods-container .payment-method {\n  display: flex;\n  align-items: center;\n}\n\n.payment-methods-container .payment-method input {\n  margin-right: 10px;\n}\n\n.payment-methods-container .selected-methods {\n  margin-top: 20px;\n}\n\n.payment-methods-container .selected-methods h6 {\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.payment-methods-container .selected-methods ul {\n  list-style-type: disc;\n  padding-left: 20px;\n}\n\n.payment-methods-container .selected-methods p {\n  font-style: italic;\n  color: #888;\n}\n\n.update-btn {\n  background-color: #0584fe;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 15px;\n  transition: background-color 0.3s;\n}\n\n.payment-methods-container .update-btn:hover {\n  background-color: #0467c4;\n}\n\n.payment-methods-container .update-message {\n  margin-top: 10px;\n  color: #106745;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.currencies-container {\n  padding: 20px;\n  border-radius: 8px;\n  margin: 20px auto;\n}\n\n.currencies-container h5 {\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.currencies-container .currencies-list {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* Three currencies per row */\n  gap: 15px;\n}\n\n.currencies-container .currency-option {\n  display: flex;\n  align-items: center;\n}\n\n.currencies-container .currency-option input {\n  margin-right: 10px;\n}\n\n.currencies-container .selected-currencies {\n  margin-top: 20px;\n}\n\n.currencies-container .selected-currencies h6 {\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n.currencies-container .selected-currencies ul {\n  list-style-type: disc;\n  padding-left: 20px;\n}\n\n.currencies-container .selected-currencies p {\n  font-style: italic;\n  color: #888;\n}\n\n.currencies-container .update-btn {\n  background-color: #0584fe;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 15px;\n  transition: background-color 0.3s;\n}\n\n.currencies-container .update-btn:hover {\n  background-color: #0467c4;\n}\n\n.currencies-container .update-message {\n  margin-top: 10px;\n  color: #106745;\n  font-weight: 600;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
